import { Injectable } from "@angular/core";
import { ClusterProductPageableResult } from "src/app/ui/models/domains/pbm/clusters/cluster-product-pageable-result.model";
import { AbstractParser } from "../../parser";
import { parseClustersProducts } from "./cluster-functions";

@Injectable()
export class ClusterProductsPageableResultParser extends AbstractParser<ClusterProductPageableResult> {
  parse(payload: any): ClusterProductPageableResult {
    const clusterProductsPageableResult = new ClusterProductPageableResult();
    clusterProductsPageableResult.setStart(payload.Start);
    clusterProductsPageableResult.setTotal(payload.Total);
    clusterProductsPageableResult.setTotalPerPages(payload.TotalPerPages);
    clusterProductsPageableResult.setData(parseClustersProducts(payload.Data));

    return clusterProductsPageableResult;
  }
}
